module.exports = __webpack_public_path__ + "static/media/pic11.bba9943c.jpg";